/**
 * Created by Administrador on 11/29/2016.
 */
(function() {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'main': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['error', 'home']);
                    }]
                }
            })
            .state('accessdenied', {
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'main': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['error', 'home']);
                    }]
                }
            });
    }
})();
